/** The views the Pull Requests tab can show in the main section. */
enum PrView {
  Contributors = 'contributors',
  Code = 'code',
  Lineage = 'lineage',
}

const PR_VIEWS: PrView[] = Object.values(PrView);

export { PR_VIEWS, PrView };
